<title mat-dialog-title>{{ 'auth.mouDialog.title' | t }}</title>
<mat-dialog-content>
  <p>{{ 'auth.mouDialog.warningMessage' | t }}</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button color="danger" (click)="close()">{{ 'common.understood' | t }}</button>
</mat-dialog-actions>
